import { cn } from 'noddi-ui-common';
import { Portal as PortalPrimitive } from 'radix-ui';
import { PropsWithChildren, useContext } from 'react';
import { OverlayActionsSlot } from './OverlayActionsSlot';

type Props = PropsWithChildren<{
  className?: string;
}>;

/**
 * The action row (Cancel / Save) of content that does not own its overlay: a form or editor
 * component rendered in a `NoddiDialog` / `NoddiSheet` body, or on a page.
 *
 * Inside an overlay it renders into the overlay's pinned footer, so a body that outgrows the
 * viewport scrolls without taking its buttons along. Anywhere else it renders in place,
 * right-aligned. An overlay that owns its actions passes them to its `footer` prop instead.
 *
 * In an overlay the row leaves the body's DOM, so a submit button in it is outside the `<form>`:
 * give it `formId={FORM_ID}` (enforced by `noddi/overlay-actions-in-footer`).
 */
export const NavioOverlayActions = ({ children, className }: Props) => {
  const slot = useContext(OverlayActionsSlot);
  const row = <div className={cn('flex flex-wrap justify-end gap-2', className)}>{children}</div>;

  if (slot === undefined) {
    return row;
  }
  return slot && <PortalPrimitive.Root container={slot}>{row}</PortalPrimitive.Root>;
};
